<template>
  <label
    :for="computedId"
    class="ui-textlabel text-xs relative left-0 flex w-fit"
    :data-disabled="(disabled as boolean)"
    >
    {{ (text??'')+(model??'') }}
    <!-- <i
      v-if="required"
      class="fas fa-exclamation text-red-500 !leading-[0px] mr-2 cursor-help text-[10px]"
      title="Required field"
      aria-label="Required field"
      /> -->
  </label>
</template>

<script setup lang="ts">
defineEmits(['click'])

const props = defineProps<{
	id?: string
	required?: boolean
  text?: string,
  disabled?: boolean
}>()

const model = defineModel()
const dataId = ref<string>(props?.id ?? `input-${Math.random().toString(36).substring(7)}`)

const computedId = computed(() => {
  return dataId.value
})
</script>